import React, { Component } from 'react';
import { Container, Navbar } from 'reactstrap';

import { PATHS } from 'config/paths';
import logo from 'assets/icons/logo.svg';

class SimpleMenu extends Component {
    render() {
        return (
            <section id="main-menu" className="d-print-none">
                <Navbar expand="md">
                    <Container>
                        <a
                            className="navbar-brand d-md-inline-block"
                            href={PATHS.EXTERNAL.HOME}
                        >
                            <img
                                src={logo}
                                className="img-fluid"
                                alt="Diet & Training by Ann"
                            />
                        </a>
                    </Container>
                </Navbar>
            </section>
        );
    }
}

export default SimpleMenu;
